import {useMessageContext} from "../../../contexts/MessageContext";
import {useEffect, useState} from "react";
import {getCompanyKeywords, saveCompanyKeywords} from "../../../services/CompanyService";
import {Box, Button, Chip, Paper, TextField} from "@mui/material";
import {Autocomplete} from "@mui/lab";

const CompanyKeywordsTag = ({company, setLoader}) => {

  const {notificationHandler} = useMessageContext();

  const [companyKeywords, setCompanyKeywords] = useState();

  const [reload, setReload] = useState(false);

  useEffect(() => {
    setLoader(true);
    getCompanyKeywords(company.id)
        .then(res => {
          setCompanyKeywords(res.data);
        }).then(() => setLoader(false))
  }, [reload]);


  const updatePrimaryKeywords = (primaryKeywords) => {
    setCompanyKeywords(prv => {
      return {...prv, primaryKeywords}
    })
  }

  const updateSecondaryKeywords = (secondaryKeywords) => {
    setCompanyKeywords(prv => {
      return {...prv, secondaryKeywords}
    })
  }

  const updateIndustryKeywords = (industryKeywords) => {
    setCompanyKeywords(prv => {
      return {...prv, industryKeywords}
    })
  }

  const updateProductKeywords = (productKeywords) => {
    setCompanyKeywords(prv => {
      return {...prv, productKeywords}
    })
  }

  const updateSeoKeywords = (seoKeywords) => {
    setCompanyKeywords(prv => {
      return {...prv, seoKeywords}
    })
  }

  const updateForbiddenWords = (forbiddenWords) => {
    setCompanyKeywords(prv => {
      return {...prv, forbiddenWords}
    })
  }

  const updateInternalLinking = (internalLinking) => {
    setCompanyKeywords(prv => {
      return {...prv, internalLinking}
    })
  }

  return (<Paper component={"form"}
                 onSubmit={(event => {
                   event.preventDefault();
                   setLoader(true);
                   // const formData = new FormData(event.currentTarget);
                   // const formJson = Object.fromEntries(formData.entries());
                   companyKeywords.companyId = company.id;
                   saveCompanyKeywords(companyKeywords)
                       .then(() => setReload(prv => !prv))
                       .then(() => notificationHandler.success('Company Saved'))
                       .finally(() => setLoader(false))
                 })}
                 sx={{margin: "48px", padding: "24px"}} elevation={2} >
    {companyKeywords && <Box sx={{display: "flex",
      flexDirection: "column",
      alignItems: "left",
      justifyContent: "center"}}>

      <Autocomplete
          multiple
          fullWidth
          id="primary-keywords"
          sx={{mt: "16px","& .MuiAutocomplete-inputRoot" : {minHeight: "100px"}}}
          options={[].map((option) => option.title)}
          freeSolo
          value={companyKeywords.primaryKeywords}
          onChange={(event, newValue) => {
            updatePrimaryKeywords(newValue);
          }}
          renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                  <Chip variant="filled" label={option} {...getTagProps({ index })} />
              ))
          }
          renderInput={(params) => (
              <TextField
                  fullWidth
                  {...params}
                  label="Primary Keywords"
              />
          )}
      />

      <Autocomplete
          multiple
          fullWidth
          id="secondary-keywords"
          sx={{mt: "16px", "& .MuiAutocomplete-inputRoot" : {minHeight: "100px"}}}
          options={[].map((option) => option.title)}
          freeSolo
          value={companyKeywords.secondaryKeywords}
          onChange={(event, newValue) => {
            updateSecondaryKeywords(newValue);
          }}
          renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                  <Chip variant="filled" label={option} {...getTagProps({ index })} />
              ))
          }
          renderInput={(params) => (
              <TextField
                  fullWidth
                  {...params}
                  label="Secondary Keywords"
              />
          )}
      />

      <Autocomplete
          multiple
          fullWidth
          id="industry-keywords"
          sx={{mt: "16px", "& .MuiAutocomplete-inputRoot" : {minHeight: "100px"}}}
          options={[].map((option) => option.title)}
          freeSolo
          value={companyKeywords.industryKeywords}
          onChange={(event, newValue) => {
            updateIndustryKeywords(newValue);
          }}
          renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                  <Chip variant="filled" label={option} {...getTagProps({ index })} />
              ))
          }
          renderInput={(params) => (
              <TextField
                  fullWidth
                  {...params}
                  label="Industry Keywords"
              />
          )}
      />

      <Autocomplete
          multiple
          fullWidth
          id="product-keywords"
          sx={{mt: "16px", "& .MuiAutocomplete-inputRoot" : {minHeight: "100px"}}}
          options={[].map((option) => option.title)}
          freeSolo
          value={companyKeywords.productKeywords}
          onChange={(event, newValue) => {
            updateProductKeywords(newValue);
          }}
          renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                  <Chip variant="filled" label={option} {...getTagProps({ index })} />
              ))
          }
          renderInput={(params) => (
              <TextField
                  fullWidth
                  {...params}
                  label="Product Keywords"
              />
          )}
      />

      {/* New SEO Keywords field */}
      <Autocomplete
          multiple
          fullWidth
          id="seo-keywords"
          sx={{mt: "16px", "& .MuiAutocomplete-inputRoot" : {minHeight: "100px"}}}
          options={[].map((option) => option.title)}
          freeSolo
          value={companyKeywords.seoKeywords || []}
          onChange={(event, newValue) => {
            updateSeoKeywords(newValue);
          }}
          renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                  <Chip variant="filled" label={option} {...getTagProps({ index })} />
              ))
          }
          renderInput={(params) => (
              <TextField
                  fullWidth
                  {...params}
                  label="SEO Keywords"
              />
          )}
      />

      {/* New Forbidden Words/Phrases field */}
      <TextField
          fullWidth
          multiline
          minRows={3}
          maxRows={6}
          sx={{mt: "16px"}}
          label="Forbidden Words/Phrases"
          placeholder="Enter forbidden words or phrases separated by commas or new lines"
          value={companyKeywords.forbiddenWords || ''}
          onChange={(event) => {
            updateForbiddenWords(event.target.value);
          }}
      />

      {/* New Internal Linking field */}
      <TextField
          fullWidth
          multiline
          minRows={3}
          maxRows={6}
          sx={{mt: "16px"}}
          label="Internal Linking from Articles"
          placeholder="Enter internal linking guidelines or URLs"
          value={companyKeywords.internalLinking || ''}
          onChange={(event) => {
            updateInternalLinking(event.target.value);
          }}
      />

      <Box sx={{mt: "48px", display: "flex", alignItems: "center", justifyContent: "end"}}>
        <Button type="submit" variant={"contained"}>save</Button>
      </Box>
    </Box>}
  </Paper>);
};

export default CompanyKeywordsTag;
